import React, { useCallback, useEffect, useState } from 'react';
import AdminTable from './AdminTable';
import Loading from 'components/Loading';
import { useLoadGoogleMaps } from 'home/useLoadGoogleMaps';
import Box from '@material-ui/core/Box';
import usePrefectures from './usePrefectures';
import { useSnackbar } from 'notistack';
import AdminDialog from './AdminDialog';
import { AdminBox } from './useAdminBoxes';

interface Props {}

export type AdminDialogType = 'create' | AdminBox;
export type AdminDialogState = { type: AdminDialogType; isOpen: boolean };

const Admin = (props: Props) => {
  const { isLoaded, loadError } = useLoadGoogleMaps();

  const { isLoading } = usePrefectures();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => () => closeSnackbar(), [closeSnackbar]);

  const [dialog, setDialog] = useState<AdminDialogState>({
    type: 'create',
    isOpen: false,
  });

  const openDialog = useCallback((type: AdminDialogType) => {
    setDialog({ type, isOpen: true });
  }, []);

  const closeDialog = useCallback(() => {
    setDialog((p) => ({ ...p, isOpen: false }));
  }, []);

  useEffect(() => {
    if (loadError) enqueueSnackbar(loadError.message, { variant: 'error' });
  }, [loadError, enqueueSnackbar]);

  if (!isLoaded || isLoading) return <Loading />;

  return (
    <Box>
      <AdminTable openDialog={openDialog} closeDialog={closeDialog} />
      <AdminDialog dialog={dialog} closeDialog={closeDialog} />
    </Box>
  );
};

export default Admin;
